module.exports = "<div class=\"spinner-wrapper\" [ngClass]=\"className\">\r\n    <svg class=\"spinner\" viewBox=\"0 0 60 60\" xmlns=\"http://www.w3.org/2000/svg\">\r\n      <circle class=\"path\" fill=\"none\" stroke-linecap=\"round\" cx=\"30\" cy=\"30\" r=\"25\"></circle>\r\n    </svg>\r\n  </div>\r\n  "


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/spinner/spinner.component.html
// module id = ./src/app/shared/spinner/spinner.component.html
// module chunks = main